import React, { useContext, useMemo } from "react";

import { Button } from "../Button";
import { StructuredTextRenderer } from "../StructuredTextRenderer";

import GeneralPageContext from "../../templates/GeneralPageContext";

import t from "../../lib/translate";

import * as styles from "./components.module.less";

export function InquiryButton() {
    const { contactButton, contactPerson, id, type } =
        useContext(GeneralPageContext);

    const linkState = useMemo(() => {
        if (type === "camera") {
            return { selectedItemId: id };
        }

        return {};
    }, []);

    return (
        <>
            {contactButton?.url ? (
                <Button
                    renderAs="link"
                    type={"cta"}
                    to={contactButton.url}
                    icon={"mail"}
                    iconPosition={"left"}
                    className={styles.inquiryButton}
                    aria-label={t("navigation.button.inquire.now")}
                    state={linkState}
                >
                    {t("navigation.button.inquire.now")}
                </Button>
            ) : (
                <StructuredTextRenderer
                    data={contactPerson?.ctaButton}
                    itemLinkType={"cta"}
                    itemLinkIcon={"mail"}
                    itemLinkIconPosition={"left"}
                    itemLinkState={linkState}
                    className={styles.inquiryButton}
                    plainLink
                    noContainer
                />
            )}
        </>
    );
}
